import { invokeFunction } from "@/lib/functions";

export interface Skill {
  /** DB id of the skill; used to persist per-persona selection. */
  id: string;
  slug: string;
  name: string;
  description: string;
  category: "integration" | "workflow";
}

/**
 * Fetches the skill catalog. Pass `containerId` to include that project's skills
 * (the api-server scopes them by verified membership), and `aiPersonaId` to
 * apply that persona's workflow-skill selection.
 */
export async function getSkills(
  params: { containerId?: string; aiPersonaId?: string } = {},
): Promise<Skill[]> {
  const query = new URLSearchParams();
  if (params.containerId) query.set("containerId", params.containerId);
  if (params.aiPersonaId) query.set("aiPersonaId", params.aiPersonaId);
  const suffix = query.toString() ? `?${query.toString()}` : "";

  const { data, error } = await invokeFunction<{
    skills: Skill[];
    total: number;
  }>(`skills${suffix}`, { method: "GET" });

  if (error) throw new Error(`Failed to fetch skills: ${error.message}`);
  return data?.skills ?? [];
}
